import {IServiceFactory} from "../../service-factory.interface";
import {FlightDesignatorModel} from "../../booking/models/designator/flight-designator.model";
import {
    IDotRezAvailableLeg,
    IDotRezAvailableSegment
} from "../../dot-rez-api/data-contracts/booking/search-simple/search-simple.data-contracts";
import {FlightIdentifierModel} from "../../booking/models/identifier/flight-identifier.model";
import {IBookingStrategy} from "../../booking/booking-strategies/booking-strategy.interface";

export class AvailabilityLegModel {
    constructor(private readonly bookingStrategy: IBookingStrategy,
                private readonly legData: IDotRezAvailableLeg,
                private readonly segmentData: IDotRezAvailableSegment) {

    }
    get services(): IServiceFactory {
        return this.bookingStrategy.services;
    }


    get designator(): FlightDesignatorModel {
        return new FlightDesignatorModel(
            this.services,
            this.services.stations.getStation(this.legData.designator.origin),
            this.services.stations.getStation(this.legData.designator.destination),
            this.legData.designator.departure,
            this.legData.designator.arrival,
            this.legData.legInfo.departureTimeUtc,
            this.legData.legInfo.arrivalTimeUtc,
            [],
            new FlightIdentifierModel(this.legData.legInfo.operatingCarrier || this.segmentData.identifier.carrierCode,
                                      this.legData.legInfo.operatingFlightNumber || this.segmentData.identifier.identifier,
                                      this.legData.legInfo.operatedByText,
                                      this.services));
    }
}
